const convertDecimal = (value: number): number | string => {
  return value ? value.toString().replace(".", ",") : value;
};
export default convertDecimal;
